var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mapIsReady)?_c('portal-google-autocomplete',{attrs:{"host":_vm.$buildingsHost()}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }